import { render } from "./EditNews.vue?vue&type=template&id=fb6b042a"
import script from "./EditNews.vue?vue&type=script&lang=js"
export * from "./EditNews.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\Logica Yachts\\Front\\Logica-Yachts\\Dashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__